import { BUSNQuestionService, BUSNUserService } from '@takectrl-multiapp/svcs-core-business';
import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  AssetType,
  IQuestion,
  QuoteType,
  SharedConfig,
  SharedDialogService,
  QuestionFilteringType,
  QuestionType,
  DateService,
} from '@takectrl-multiapp/svcs-share-config';
import { BUSNThirdPartyService } from '@takectrl-multiapp/svcs-core-business';
import { BUSNCommunicationService } from 'libs/svcs-core-business/src/lib/services/busn-communication.service';
import { ActivatedRoute } from '@angular/router';

const ADDRESS_ID_FIELDS = ['address_id', 'daytime_address_id', 'overnight_address_id'];

@Component({
  selector: 'quote-summary-not-editable',
  standalone: false,
  templateUrl: './quote-summary-not-editable.component.html',
  styleUrls: ['./quote-summary-not-editable.component.scss'],
})
export class QuoteSummaryNotEditableComponent implements OnInit, AfterViewInit {
  @Output() navigateQuoteNew: EventEmitter<void> = new EventEmitter<void>();
  @Output() navigateWalletPage: EventEmitter<void> = new EventEmitter<void>();
  @Output() navigateWalletAsset: EventEmitter<unknown> = new EventEmitter();
  @Output() navigateSummaryEditPage: EventEmitter<unknown> = new EventEmitter<unknown>();
  @Input() quoteType: QuoteType;
  selectedAssetUnderwritingQuestions: IQuestion[];
  uniqueHeadings: string[];
  questionGroup = [];
  headings = [];
  header = "Let's make sure we got everything right";
  popUpHeading: string;
  popupMessage: string;
  subHeader: string;
  showUpdatePopup = false;
  vehicleYear: string;
  vehicleYearReg: string;
  vehicleMake: string;
  vehicleType: string;
  vehicleModel: string;
  QuestionType = QuestionType;
  QuoteType = QuoteType;
  asset_id: number;
  constructor(
    private readonly busnQuestionService: BUSNQuestionService,
    private readonly busnUserService: BUSNUserService,
    public sharedConfig: SharedConfig,
    public busnThirdPartyService: BUSNThirdPartyService,
    private readonly sharedDialogService: SharedDialogService,
    public dateService: DateService,
    private readonly busnCommService: BUSNCommunicationService,
    private readonly route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.showIntercom = this.showIntercom.bind(this);
  }

  async ngAfterViewInit(): Promise<void> {
    this.asset_id = Number(this.route.snapshot.queryParamMap.get('asset_id'));
    if (this.quoteType === QuoteType.MyProfile) {
      this.selectedAssetUnderwritingQuestions = await this.busnQuestionService.getPersonalOrAssetSpecificQuestions(
        SharedConfig.user,
        JSON.parse(JSON.stringify(SharedConfig.underwritingQuestionsAll)),
        AssetType.UserPersonalDetails
      );
      this.header = 'My Profile';
    } else {
      this.selectedAssetUnderwritingQuestions = await this.busnQuestionService.getPersonalOrAssetSpecificQuestions(
        SharedConfig.user,
        JSON.parse(JSON.stringify(SharedConfig.underwritingQuestionsAll)),
        SharedConfig.selectedAssetUnderwritingQuestions[0].underwriting_answers[0].object_name,
        QuestionFilteringType.hideHiddenQuestionsForSummary,
        true,
        null,
        this.asset_id
      );
    }
    if (this.quoteType === QuoteType.ViewAssetOnly) {
      this.header = 'View asset details below.';
    }
    this.questionGroup = this.busnQuestionService.initializeIndividualQuestionLoaders(
      null,
      'quote_summary_not_editable',
      this.selectedAssetUnderwritingQuestions,
      this.quoteType
    );
    for (const qGroup of this.questionGroup) {
      const vehicleSearch = qGroup.answeredQuestions.find((x) => x.question_type === QuestionType.vehicleSearch);
      if (vehicleSearch) {
        this.vehicleType = vehicleSearch.underwriting_answers.find((x) => x.object_field === 'vehicle_type').object_answer;
        this.vehicleYearReg = vehicleSearch.underwriting_answers.find((x) => x.object_field === 'year_of_registration').object_answer;
        this.vehicleYear = vehicleSearch.underwriting_answers.find((x) => x.object_field === 'year_of_manufacture').object_answer;
        this.vehicleMake = vehicleSearch.underwriting_answers.find((x) => x.object_field === 'make').object_answer;
        this.vehicleModel = vehicleSearch.underwriting_answers.find((x) => x.object_field === 'model').object_answer;
      }

      const addressQuestions = qGroup.answeredQuestions.filter((x) => x.question_type === QuestionType.address);
      for (const addressQuestion of addressQuestions) {
        const addressAnswer = addressQuestion.underwriting_answers.find((x) => ADDRESS_ID_FIELDS.includes(x.object_field));
        if (addressAnswer?.object_answer) {
          addressAnswer.address_object = await this.busnUserService.getAddressBasedOnID(addressAnswer.object_answer);
        }
      }
    }
  }

  isEmptyAnswer(answer: any): boolean {
    if (answer.object_answer === null || answer.object_answer === undefined) return true;
    if (typeof answer.object_answer === 'string' && answer.object_answer.trim() === '') return true;
    if (Array.isArray(answer.object_answer) && answer.object_answer.length === 0) return true;
    return false;
  }

  async edit(groupHeading: string) {
    if (this.quoteType === QuoteType.MyProfile) {
      this.sharedDialogService.showPopupDialog({
        header: 'Information',
        subHeader: 'If you would like to update your personal information, please chat to us',
        buttonOneText: 'Chat to us',
        buttonOneCallback: this.showIntercom,
        buttonTwoText: 'Cancel',
        buttonTwoCallback: this.sharedDialogService.hidePopupDialog,
      });
    } else {
      this.navigateSummaryEditPage.emit(groupHeading);
      SharedConfig.summaryFilteredHeading = groupHeading;
    }
  }

  showIntercom() {
    this.busnCommService.openContactCardPopup()
    this.sharedDialogService.hidePopupDialog();
  }

  confirm() {
    if (this.quoteType === QuoteType.StandardQuoteRequest) {
      this.navigateQuoteNew.emit();
    } else {
      this.navigateWalletPage.emit();
    }
  }
  setDateFormat(date_full) {
    const date = new Date(date_full);
    return date.toLocaleString('default', { month: 'long', year: 'numeric' });
  }
}
